/**
 * Folds ALL legacy package-id normalization into ONE place — the single
 * `canonicalId()` the design calls for, replacing the per-adapter id strategies
 * (flip-cards `getEpochId`, carousel `config.id`, marquee `packName`, etc.).
 *
 * Strips the product-line prefixes so a package-config id and the CMS token
 * segment collapse to ONE canonical id:
 *   ATT_TV_MYSPORTS → MYSPORTS,  ATT_TV_ENTERTAINMENT → ENTERTAINMENT,
 *   DTV_TV_CHOICE / DTV_CHOICE  → CHOICE.
 * So authors write the clean `<GENRE_MYSPORTS_…>` (no ATT_TV_/DTV_ cruft) and it
 * matches the registry key built from the raw id. The token's productType
 * (INTERNET vs SATELLITE) disambiguates same-named packages (ENTERTAINMENT on
 * both). Order matters: DTV_TV_ before DTV_.
 */
export function canonicalPackageId(rawId: string | null | undefined): string {
  if (!rawId) {
    return "";
  }
  return String(rawId)
    .trim()
    .toUpperCase()
    .replace(/^ATT_TV_/, "")
    .replace(/^DTV_TV_/, "")
    .replace(/^DTV_/, "");
}

export default canonicalPackageId;
